export default "__VITE_ASSET__OcqcuvbS__"